import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { environment } from "../../environments/environment";
import { ArticleService } from "../service/article.service";
import { LazyImgDirective } from "../lazy-img.directive";
import { ImgFallbackDirective } from "../shared/img-fallback.directive";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-new-screen-six",
  templateUrl: "./new-screen-six.component.html",
  styleUrls: ["./new-screen-six.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LazyImgDirective, ImgFallbackDirective, MatButton]
})
export class NewScreenSixComponent implements OnInit {
  conv: object[] = [];
  private curated = false;

  constructor(
    private service: ArticleService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.video_feature();
    this.applyCuration();
  }
  video_feature() {
    this.service
      .get_article({ main_category: "tv", limit: 12 })
      .subscribe(data => {
        // Editor curation wins the race (see applyCuration).
        if (this.curated) { this.cdr.markForCheck(); return; }
        if (data["success"]) {
          this.conv = data["data"];
        }
        this.cdr.markForCheck();
      });
  }

  // Editor-curation overlay (SSR-safe: override-with-guard). Empty/error → auto stays.
  applyCuration() {
    this.service.getPageLayoutCached("homepage").subscribe(
      (res: any) => {
        const sections = (res && res.data && res.data.sections) || [];
        const sec = sections.find((s: any) => s && s.key === "featured-tv");
        if (sec && Array.isArray(sec.articles) && sec.articles.length) {
          this.conv = sec.articles;
          this.curated = true;
        }
        this.cdr.markForCheck();
      },
      () => {}
    );
  }

  buildHrefLink(story: string) {
    let href_link = environment.frontend_url;
    switch (story["main_category"]) {
      case "insights":
        href_link += `insights/${story["category"]}/${story["blog_category"]}/`;
        break;
      case "podcast":
        href_link += `podcast/${story["event"]}/`;
        break;
      default:
        href_link += `tv/${story["event"]}/${story["category"]}/`;
    }
    return href_link + story["slug"];
  }
}
